export function majorityThreshold(totalSeats) {
    return Math.floor(totalSeats / 2) + 1;
}
export function isWinning(parties, seatsByParty, totalSeats) {
    const sum = parties.reduce((a, p) => a + (seatsByParty[p] ?? 0), 0);
    return sum >= majorityThreshold(totalSeats);
}
/** Alla vinnande koalitioner + minimala vinnande koalitioner + Banzhaf-maktindex. */
export function analyzeCoalitions(seatsByParty, totalSeats) {
    const majority = majorityThreshold(totalSeats);
    // Endast partier med minst ett mandat kan ingå.
    const parties = Object.keys(seatsByParty).filter((p) => (seatsByParty[p] ?? 0) > 0);
    const n = parties.length;
    if (n > 20) {
        throw new Error(`För många partier för uttömmande koalitionssökning: ${n}`);
    }
    const allWinning = [];
    const minimalWinning = [];
    const pivotalCount = Object.fromEntries(parties.map((p) => [p, 0]));
    const inWinningCount = Object.fromEntries(parties.map((p) => [p, 0]));
    let totalSwings = 0;
    for (let mask = 1; mask < 1 << n; mask++) {
        const members = [];
        let seats = 0;
        for (let i = 0; i < n; i++) {
            if (mask & (1 << i)) {
                const p = parties[i];
                members.push(p);
                seats += seatsByParty[p] ?? 0;
            }
        }
        if (seats < majority)
            continue;
        const coalition = { parties: members, seats, margin: seats - majority };
        allWinning.push(coalition);
        for (const p of members)
            inWinningCount[p] = (inWinningCount[p] ?? 0) + 1;
        // Minimal om varje medlem är kritisk.
        let minimal = true;
        for (const p of members) {
            const critical = seats - (seatsByParty[p] ?? 0) < majority;
            if (critical) {
                pivotalCount[p] = (pivotalCount[p] ?? 0) + 1;
                totalSwings++;
            }
            else {
                minimal = false;
            }
        }
        if (minimal)
            minimalWinning.push(coalition);
    }
    const bySizeThenSeats = (a, b) => a.parties.length - b.parties.length || b.seats - a.seats;
    allWinning.sort(bySizeThenSeats);
    minimalWinning.sort(bySizeThenSeats);
    const power = {};
    for (const p of parties) {
        power[p] = {
            pivotalCount: pivotalCount[p] ?? 0,
            index: totalSwings > 0 ? (pivotalCount[p] ?? 0) / totalSwings : 0,
            inWinningCount: inWinningCount[p] ?? 0,
        };
    }
    return { totalSeats, majority, minimalWinning, allWinning, power };
}
//# sourceMappingURL=coalitions.js.map